import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Stack, Button, Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useAppSelector } from "../../store";
import { admin } from "../../features/session/sessionSlice";
import { isPreRegistrationEntryFlow } from "../../utils/registerFlow";

interface RegisterThanksProps {}

const RegisterThanks: FC<RegisterThanksProps> = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isAdmin = useAppSelector(admin);
  const isPreRegistrationEntry = isPreRegistrationEntryFlow();
  const entryRoute = !isAdmin && isPreRegistrationEntry ? "/pre-registration" : "/register";

  return (
    <Stack spacing={4} alignItems="center" maxWidth={800} mx="auto">
      {/* Alert Success */}
      <Alert
        severity="success"
        variant="outlined"
        sx={{
          borderColor: "success.main",
          borderLeft: `4px solid ${theme.palette.success.main}`,
          bgcolor: isDark ? "rgba(76, 175, 80, 0.15)" : "success.light",
          color: isDark ? "success.light" : "success.contrastText",
          fontWeight: 500,
          width: "100%",
          maxWidth: 800,
        }}
      >
        Votre inscription a réussi.
      </Alert>

      {/* Alert Info */}
      <Alert
        severity="info"
        variant="outlined"
        sx={{
          borderLeft: `4px solid ${theme.palette.secondary.main}`,
          borderColor: isDark
            ? alpha(theme.palette.secondary.light, 0.45)
            : alpha(theme.palette.secondary.main, 0.4),
          bgcolor: isDark
            ? alpha(theme.palette.secondary.main, 0.12)
            : alpha(theme.palette.secondary.main, 0.08),
          color: isDark ? theme.palette.grey[50] : theme.palette.text.primary,
          fontWeight: 500,
          width: "100%",
          maxWidth: 800,
          "& .MuiAlert-icon": {
            color: isDark ? theme.palette.secondary.light : theme.palette.secondary.dark,
          },
        }}
      >
        Un e-mail de confirmation vous a été envoyé.
      </Alert>

      {/* Button to Register Another Player */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          sx={{
            padding: "10px 20px",
            fontWeight: 600,
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
            },
          }}
          onClick={() => {
            navigate(entryRoute);
          }}
        >
          Inscrire un autre joueur
        </Button>
      </Box>
    </Stack>
  );
};

export default RegisterThanks;
